<!--补货单-->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container recharge-manage">
      <div v-if="activeIndex === 0">
        <el-form label-width="130px">
          <el-row :gutter="20">
            <el-col :md="8" :lg="8" :xl="8">
              <el-form-item size="mini" :label="$t('required.input.agentNo')">
                <el-input :class="{ 'disabled_remove_css': memberNoDisabled }" disabled v-model.trim="userCode" clearable
                  :placeholder="$t('')" />
              </el-form-item>
            </el-col>
            <el-col :md="12" :lg="8" :xl="6">
              <p :class="{ 'account_name_css': account_name_show }"
                style="color:#538E0D; font-weight:bold; line-height: 4px;">{{ listQuery.accountName }}</p>
            </el-col>
          </el-row>
        </el-form>
        <div style="text-align: center; margin-bottom: 10px">
          <!--      下一步-->
          <el-button size="mini" :disabled="oneNextIf" :loading="btnloading" type="success" icon="el-icon-right"
            @click="buttonnext">{{ $t('button.next') }}
          </el-button>
          <!--      取消-->
          <el-button size="mini" :loading="btnloading" type="danger" icon="el-icon-close" @click="buttoncancel">
            {{ $t('operation.button.cancel') }}
          </el-button>
        </div>
      </div>
      <div v-if="activeIndex === 1">
        <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
        <el-form label-width="130px" :model="listQuery1">
          <!--        代办处编号-->
          <el-form-item size="mini" style="width: 400px" :label="$t('miAgent.agentNo')">
            <el-input :class="{ 'disabled_remove_css': memberNoDisabled }" disabled v-model.trim="listQuery1.agentNo" />
          </el-form-item>
          <!--        收货人姓名-->
          <el-form-item size="mini" style="width: 400px" :label="$t('PoOrder.recName')">
            <el-input :class="{ 'disabled_remove_css': memberNoDisabled }" disabled v-model.trim="listQuery1.name" />
          </el-form-item>
          <!--        联系电话-->
          <el-form-item size="mini" style="width: 400px" :label="$t('sysCompany.phone')">
            <el-input :class="{ 'disabled_remove_css': memberNoDisabled }" disabled v-model.trim="listQuery1.mobile" />
          </el-form-item>
          <!--        详细地址-->
          <el-form-item size="mini" style="width: 400px" :label="$t('miAgent.storeAddr')">
            <el-input :class="{ 'disabled_remove_css': memberNoDisabled }" disabled
              v-model.trim="listQuery1.storeAddr" />
          </el-form-item>
          <!--        备注-->
          <el-form-item size="mini" style="width: 400px" :label="$t('poReturn.createRemark')">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 10 }" v-model.trim="listQuery1.remark" />
          </el-form-item>
        </el-form>
        <h3 style="color: #b3640d">{{ $t('mall.ProductsList') }}</h3>
        <p style="color:#538E0D; font-size:14px; font-weight:bold;">{{ $t('pmEfuboCard.amount') }} <span
            style="color:#F00; font-size:14px; font-weight:bold;">{{ totalfA }}</span> FV <span
            style="color:#F00; font-size:14px; font-weight:bold;">{{ totalFv }}</span></p>
        <el-table :key="tableKey" v-loading="listLoading" :data="list" border size="mini" fit highlight-current-row
          style="width: 100%;">
          <!--     预览 -->
          <!--<el-table-column :label="$t('button.preview')" prop="photoName" align="center" />-->
          <!--      商品编码-->
          <el-table-column :label="$t('BiGoods.goodsCode')" prop="goodsCode" align="center" />
          <el-table-column :label="$t('BiGoods.goodsCode.old')" prop="oldcode" align="center" />
          <!--      商品名称-->
          <el-table-column :label="$t('BiGoods.name')" prop="name" align="center" />
          <!--      价格-->
          <!--          <el-table-column :label="$t('pd.price')" prop="standardPrice" align="center" />-->
          <!--      积分-->
          <!--          <el-table-column :label="$t('FV')" prop="standardPv" align="center" />-->
          <!--      是否赠品    -->
          <!--          <el-table-column :label="$t('Is.it.a.physical.point')" prop="productForm" align="center">-->
          <!--            <template v-slot="{row}">-->
          <!--              {{$lt(initDict.physicalpoint,row.productForm)}}-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--      可用库存量-->
          <el-table-column :label="$t('stStock.validQty')" prop="validQty" align="center" />
          <!--      购买数量-->
          <el-table-column :label="$t('Common.buyNumber')" prop="quantity" align="center">
            <template v-slot="{ row }">
              <el-input v-model.number="row.quantity" />
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center; margin-top: 20px">
          <!--      上一步-->
          <el-button size="mini" :loading="btnloading" type="success" icon="el-icon-back" @click="buttonprevious">
            {{ $t('button.previous') }}
          </el-button>
          <!--      下一步-->
          <el-button size="mini" :loading="btnloading" type="success" icon="el-icon-right" @click="buttonnext1">
            {{ $t('button.next') }}
          </el-button>
        </div>
      </div>
      <div v-if="activeIndex === 2">
        <el-form label-width="150px">
          <!--          支付信息-->
          <h3 style="color: #b3640d">{{ $t('title.payment.info') }}</h3>
          <!--         商品总金额 -->
          <el-form-item :label="$t('poAssistMemberOrder.productAmount')">
            {{ totalfA }}
          </el-form-item>
        </el-form>
        <table>
          <thead>
            <tr>
              <th>{{ $t('BiGoods.goodsCode') }}</th>
              <th>{{ $t('BiGoods.goodsCode.old') }}</th>
              <th>{{ $t('BiGoods.name') }}</th>
              <th>{{ $t('pd.price') }}</th>
              <th>{{ $t('busi.direct.sale_points') }}</th>
              <!--            <th>{{ $t('Is.it.a.physical.point') }}</th>-->
              <th>{{ $t('Common.buyNumber') }}</th>
              <th>{{ $t('order.price.total') }}</th>
              <th>{{ $t('order.pv.total') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="i in list3" :key="i.id">
              <td>{{ i.goodsCode }}</td>
              <td>{{ i.oldcode }}</td>
              <td>{{ i.name }}</td>
              <td>{{ i.standardPrice }}</td>
              <td>{{ i.standardPv }}</td>
              <!--            <td>{{$lt(initDict.physicalpoint,i.productForm) }}</td>-->
              <td>{{ i.quantity }}</td>
              <td>{{ i.standardPrice * i.quantity }}</td>
              <td>{{ i.standardPv * i.quantity }}</td>
            </tr>
            <tr>
              <td>{{ $t('poOrder.amtCount') }}</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>{{ quantity }}</td>
              <td>{{ totalfA }}</td>
              <td>{{ totalFv }}</td>
            </tr>
          </tbody>
        </table>
        <div style="text-align: center; margin-bottom: 10px;margin-top: 10px">
          <!--        上一步-->
          <el-button size="mini" :loading="btnloading" type="success" icon="el-icon-back" @click="buttonprevious3">
            {{ $t('button.previous') }}
          </el-button>
          <!--        提交-->
          <el-button size="mini" :loading="btnloading" type="success" icon="el-icon-check" @click="titlesubmit">
            {{ $t('title.submit') }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAlRegionsByCode, getLevel1AlRegions, miAgentInfo } from "@/api/member"
import { getStockWarehouseAgentsByNo, poOrderAgentAdd } from "@/api/agent";
import { StockNumberString } from "@/utils/stock-number-string";

export default {
  name: "ReplenishmentOrder",
  data() {
    return {
      memberNoDisabled: true,
      account_name_show: false,
      oneNextIf: false,
      activeIndex: 0,
      agentNo: null,
      listQuery: {
        accountName: null
      },
      listQuerydata: {},
      listQuery1: {
        storeAddr: null,
        name: null,
        mobile: null
      },
      listQuery2: {},
      listQuery3: {},
      list3: [],
      tableKey: 0,
      listLoading: false,
      list: [],
      btnloading: false,
      open: false,
      //  地区
      sltloading: false,
      country: null,
      province: null,
      city: null,
      district: null,
      initDict: {
        physicalpoint: 'Is.it.a.physical.point'
      }
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'companyCode',
      'isAgent'
    ]),
    totalfA() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.standardPrice * cur.quantity + acc
      }, 0).toFixed(2)
    },
    totalFv() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.standardPv * cur.quantity + acc
      }, 0).toFixed(2)
    },
    quantity() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.quantity + acc
      }, 0)
    }
  },
  created() {
    this.getAgentno()
    this.getCountry()
  },
  methods: {
    StockNumberString,
    //国
    getCountry() {
      getLevel1AlRegions().then(res => {
        this.country = res.data
      }).catch(err => {
        console.error(err)
      })
    },
    //省
    getProvince() {
      if (!this.listQuery1.country) {
        this.listQuery1.province = null
        this.listQuery1.city = null
        this.listQuery1.district = null
      } else {
        this.sltloading = true
        getAlRegionsByCode({ 'regionCode': this.listQuery1.country }).then(res => {
          this.listQuery1.province = null
          this.listQuery1.city = null
          this.listQuery1.district = null
          this.province = res.data
          this.sltloading = false
        }).catch(err => {
          this.sltloading = false
          console.error(err)
        })
      }
    },
    //市
    getcity() {
      this.sltloading = true
      getAlRegionsByCode({ 'regionCode': this.listQuery1.province }).then(res => {
        this.listQuery1.city = null
        this.listQuery1.district = null
        this.city = res.data
        this.sltloading = false
      }).catch(err => {
        this.sltloading = false
        console.error(err)
      })
    },
    //区
    getdistrict() {
      this.sltloading = true
      getAlRegionsByCode({ 'regionCode': this.listQuery1.city }).then(res => {
        this.district = res.data
        this.sltloading = false
      }).catch(err => {
        this.sltloading = false
        console.error(err)
      })
    },
    getAgentno() {
      miAgentInfo({ 'agentNo': this.userCode }).then(res => {
        this.listQuerydata = res.data
        this.listQuery.storeAddr = res.data.storeAddr
        this.listQuery1.storeAddr = res.data.storeAddr
        this.listQuery.accountName = res.data.name
        this.listQuery1.agentNo = res.data.agentNo
        this.listQuery.name = res.data.agentName
        this.listQuery1.name = this.listQuerydata.name
        this.listQuery1.mobile = this.listQuerydata.mobile
        this.listQuery1.storeAddr = this.listQuerydata.storeAddr
        this.btnloading = false
        this.open = true
        this.oneNextIf = false
        this.account_name_show = false
      }).catch(err => {
        this.listQuery.accountName = ''
        this.account_name_show = true
        this.oneNextIf = true
        this.btnloading = false
        console.error(err)
      })
    },
    buttonnext() {
      this.list = []
      getStockWarehouseAgentsByNo({ 'agentNo': this.agentNo }).then(res => {
        let excludeGoodsList = [
          'PAC01',
          'PAC02',
          'PK01224',
          'PK01324',
          'PK01424',
          'FVT-F012',
          'PK02724',
          'PK02824',
          'AF-N000005-24',
          'AF-N000006-24',
          'AF-N000007-24',
          'AF-N000004-24',
          'AF-N000009-24',
          'AF-N000008-24',
          'AF-N000010-25',
          'AF-N000011-25',
          'AF-N000008-24',
          'AF-N000012-25',
          'AF-N000013-25'
        ]
        res.data.forEach(v => {
          v.quantity = v.validQty
          if (!excludeGoodsList.includes(v.goodsCode)) {
            this.list.push(v)
          }
        })
        // this.list = res.data
        this.btnloading = false
        this.activeIndex = 1
      }).catch(err => {
        console.error(err)
      })
    },
    buttoncancel() {
      this.$router.back()
    },
    buttonprevious() {
      this.activeIndex = 0
    },
    buttonnext1() {
      let IfNumber = 0
      for (let a = 0; a < this.list.length; a++) {
        if (this.list[a].quantity > 0) {
          IfNumber++
        }
        if (this.list[a].quantity > 1 * this.list[a].validQty) {
          return this.$message(this.$t('Please.Enter.Quantity')) // 请输入正确的数量
        }
      }
      if (IfNumber === 0) {
        return this.$message(this.$t('leastInputANumber')) // 请至少输入一个购买数量
      }
      this.activeIndex = 3
      for (let a = 0; a < this.list.length; a++) {
        if (this.list[a].quantity > 0) {
          this.list3.push(this.list[a])
        }
      }
      for (let i = 0; i < this.list3.length; i++) {
        if (this.list3[i].quantity <= 0) {
          this.list3.splice(i, 1)
        }
      }
      this.activeIndex = 2
    },
    buttonprevious3() {
      this.list3 = []
      this.activeIndex = 1
    },
    titlesubmit() {
      let details = []
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].quantity > 0) {
          details.push(this.list[i])
        }
      }
      this.listQuery1.details = details
      this.btnloading = true
      poOrderAgentAdd({ ...this.listQuery1 }).then(() => {
        this.btnloading = false
        this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        this.$router.push({ name: 'TurnoverOrderList' })
      }).catch(err => {
        this.btnloading = false
        console.error(err)
        this.$message.error(this.$t('bdSendRegister.operaterFail'))
      })
    }
  }
}
</script>

<style scoped lang="scss">
table {
  margin: 20px 0 20px 0px;
  width: 100%;
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;

  tr {
    th {
      width: 150px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid black;
    }

    td {
      width: 200px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid black;
    }
  }

  thead {
    th {
      font-size: 18px;
      border-right: 1px solid black;
      width: 400px;
    }
  }

  tbody {
    td {
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      font-size: 14px;
      border: 1px solid black;
      width: 200px;
    }
  }
}

.account_name_css:after {
  content: 'X';
  color: #ff4949;
}

.disabled_remove_css {
  ::v-deep .el-input__inner {
    background-color: white;
    color: black;
  }
}
</style>
